// extracted by mini-css-extract-plugin
export default {"modalHeader":"Taa-z","modalContent":"Uaa-z","formWrapper":"Vaa-z","fade":"Waa-z","fade-in":"Xaa-z"};